import { uuidv7 } from 'uuidv7';

/**
 * Every id in the database is a UUIDv7 (PLAN §7): time-ordered, so inserts stay
 * local in the index and rows sort by creation without a separate column.
 * PostgreSQL's `gen_random_uuid()` emits v4, so ids are made here instead.
 */
export function newId(): string {
  return uuidv7();
}
